import { BigNumber } from '@ethersproject/bignumber'
import { ethers } from 'ethers'
import { PancakePairABI, ERC20ABI } from '@/config'
import { formatEther } from 'viem'

export const getDeadline = () => {
  const newTime = new Date().getTime()
  const deadline = parseInt((newTime / 1000).toString()) + 600
  return deadline
}

/**
 * //两个数之间随机整数 含最大值，含最小值
 * @param min 
 * @param max 
 * @returns number 类型
 */
export function getRandomNumber(min: number, max: number) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1)) + min
}

/**
 * 
 * @param spenAddress 花费代币地址
 * @param pairAddress 池子代币
 * @param WETH WETH
 * @param tokenAddress 代币地址
 * @returns 
 */
export function getBuyPath(spenAddress: string, pairAddress: string, WETH: string, tokenAddress: string) {
  const _pairAddress = pairAddress.toLocaleLowerCase()
  const _spenAddress = spenAddress.toLocaleLowerCase()
  const _WETH = WETH.toLocaleLowerCase()
  const path = (_spenAddress === _WETH) ? [WETH] : [spenAddress, WETH]
  const before = (_pairAddress === _WETH) ? [tokenAddress] : [pairAddress, tokenAddress]
  return path.concat(before)
}

// add 10%
export function calculateGasMargin(value: BigNumber, margin = 1000): BigNumber {
  return value.mul(BigNumber.from(10000).add(BigNumber.from(margin))).div(BigNumber.from(10000))
}


export const getTime = (time: number) => {
  //将时间戳转换成时间格式
  // d.cTime = 1539083829787
  const date = new Date(time)
  const year = date.getFullYear()

  const month = date.getMonth() + 1
  let mon = `${month}`
  if (month < 10) mon = `0${month}`

  const day = date.getDate()
  let d = `${day}`
  if (day < 10) d = `0${day}`

  const hour = date.getHours()
  let h = `${hour}`
  if (hour < 10) h = `0${hour}`

  const min = date.getMinutes()
  let m = `${min}`
  if (min < 10) m = `0${min}`

  const sec = date.getSeconds()
  let s = `${sec}`
  if (sec < 10) s = `0${sec}`

  return `${h}:${m}:${s}`
}


export const getOnGasFee = (result: any) => {
  const gasPrice = result.effectiveGasPrice as bigint
  const gasUsed = result.gasUsed as bigint

  const gasFee = gasPrice * gasUsed

  return formatEther(gasFee)
}
export const errorHandler = (info: any) => {
  let error = JSON.parse(JSON.stringify(info))
  console.log(error)
  let reason: string | undefined
  reason = error.reason ?? error.data?.message ?? error.message ?? reason

  // if (reason?.indexOf('execution reverted: ') === 0) reason = reason.substring('execution reverted: '.length)
  if (reason === 'insufficient funds for intrinsic transaction cost') return `钱包资金不足`
  if (reason === 'missing revert data in call exception; Transaction reverted without a reason string') return `网络错误`
  if (reason === 'missing response') return `网络错误`
  if (reason === 'could not detect network') return `网络错误`
  if (reason === 'execution reverted: TransferHelper: TRANSFER_FROM_FAILED') return `当前钱包花费代币数量不足`
  if (reason === 'cannot estimate gas; transaction may fail or may require manual gas limit') return `当前钱包支付gas费用不足`
  return reason
}

// 代币  池子类型
export const currentPriceHandler = (reserve0: BigNumber, reserve1: BigNumber, decimals0: number, decimals1: number) => {
  const ETHAmount = ethers.utils.formatUnits(reserve1, decimals1)
  const TokenAmount = ethers.utils.formatUnits(reserve0, decimals0)
  const ETH = ethers.utils.parseEther(ETHAmount)
  const Token = ethers.utils.parseEther(TokenAmount)
  const price = ETH.mul(ethers.constants.WeiPerEther).div(Token)
  const _price = ethers.utils.formatEther(price)
  return _price
}

export interface PoolType {
  amount0: ethers.BigNumber;
  amount1: ethers.BigNumber;
  symbol0: string;
  symbol1: string;
  decimals0: number;
  decimals1: number;
}

export const getPoolAmount = (pairAddress: string, wallet, contractAddress: string) => {
  return new Promise(async (resolve: (value: PoolType) => void, reject) => {
    try {
      const pairContract = new ethers.Contract(pairAddress, PancakePairABI, wallet)
      const res = await pairContract.getReserves()
      // 默认池子0是代币 1是ETH
      let amount0 = res._reserve0
      let amount1 = res._reserve1

      const token0: string = await pairContract.token0()
      const token1: string = await pairContract.token1()
      const contract0 = new ethers.Contract(token0, ERC20ABI, wallet)
      const contract1 = new ethers.Contract(token1, ERC20ABI, wallet)

      const s0 = await contract0.symbol()
      const s1 = await contract1.symbol()
      const d0 = await contract0.decimals()
      const d1 = await contract1.decimals()

      let symbol0 = s0
      let symbol1 = s1
      let decimals0 = d0
      let decimals1 = d1
      if (token1.toLocaleLowerCase() === contractAddress.toLocaleLowerCase()) {
        amount0 = res._reserve1
        amount1 = res._reserve0
        symbol0 = s1
        symbol1 = s0
        decimals0 = d1
        decimals1 = d0
      }
      // 代币数量， ETH数量， 代币符号， ETH符号
      resolve({ amount0, symbol0, decimals0, amount1, symbol1, decimals1 })
    } catch (error) {
      reject(error)
    }
  })
}

export const logInterFaceTransFer = (interFaceTransFer: ethers.utils.Interface, log: any, decimals: number) => {
  const transFerData = interFaceTransFer.parseLog(log)
  const value = ethers.utils.formatUnits(transFerData.args.value, decimals)
  return value
}


/**
 * 倒计时
 * @param date YYYY-MM-DD hh:mm
 * @returns D H M S
 */
export const downTimeHandler = function (date: string | number | Date) {
  const nowtime = new Date() //获取当前时间
  const endtime = new Date(date) //定义结束时间

  const lefttime = endtime.getTime() - nowtime.getTime() //距离结束时间的毫秒数

  if (lefttime < 0) return ['00', '00', '00', '00', lefttime]

  const day = Math.floor(lefttime / (1000 * 60 * 60 * 24)) //计算天数
  let d = `${day}`
  if (day < 10) d = `0${day}`

  const hour = Math.floor((lefttime / (1000 * 60 * 60)) % 24) //计算小时数
  let h = `${hour}`
  if (hour < 10) h = `0${hour}`

  const min = Math.floor((lefttime / (1000 * 60)) % 60) //计算分钟数
  let m = `${min}`
  if (min < 10) m = `0${min}`

  const sec = Math.floor((lefttime / 1000) % 60) //计算秒数
  let s = `${sec}`
  if (sec < 10) s = `0${sec}`

  return [d, h, m, s, lefttime] //返回倒计时的字符串
}